import React from 'react'
// import Notifications from './Notifications'
import ThemeChosen from './ThemeChosen'
import './toolBar.css'

const ToolBar = props => {
    return (
        <div style={{marginLeft: '-13px', marginRight: '-5px'}}>

        <div className='toolbar-container' style={props.zero ? {marginBottom: 0} : null}>

            <div className='toolbar-children-area' id="toolbar-children">
                {props.children}
            </div>

            {/* Notify Icon */}
            <div className='toolbar-icon-area'>
             {/* <Notifications /> */}
             <ThemeChosen />
            </div>

        </div>
        </div>
    )
}

export default ToolBar